<div class="card-body">
    <div id="apex-simple-pie-chart"></div>
</div>